import { useStrictLocalization } from "@faire/web--source/common/localization";

import { QuickAction, QuickActionType, QuickActions } from "../types";

export const useRetailerQuickActions = (): QuickActions => {
  const { strictLocalize } = useStrictLocalization();

  const cancelAnOrder: QuickAction = {
    id: QuickActionType.CANCEL_AN_ORDER,
    label: strictLocalize({
      defaultMessage: "Cancel an order",
      description: {
        text: "Quick action button to cancel an order",
      },
    }),
  };

  const reportDamagedOrMissingItems: QuickAction = {
    id: QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS,
    label: strictLocalize({
      defaultMessage: "Report damaged/missing items",
      description: {
        text: "Quick action button to report items",
      },
    }),
  };

  const returnItems: QuickAction = {
    id: QuickActionType.RETURN_ITEMS,
    label: strictLocalize({
      defaultMessage: "Return items",
      description: {
        text: "Quick action button to return items",
      },
    }),
  };

  const contactABrand: QuickAction = {
    id: QuickActionType.CONTACT_A_BRAND,
    label: strictLocalize({
      defaultMessage: "Contact a brand",
      description: {
        text: "Quick action button to contact a brand",
      },
    }),
  };

  const trackAnOrder: QuickAction = {
    id: QuickActionType.TRACK_AN_ORDER,
    label: strictLocalize({
      defaultMessage: "Track an order",
      description: {
        text: "Quick action button to track an order",
      },
    }),
  };

  return {
    [QuickActionType.CANCEL_AN_ORDER]: cancelAnOrder,
    [QuickActionType.REPORT_DAMAGED_OR_MISSING_ITEMS]:
      reportDamagedOrMissingItems,
    [QuickActionType.RETURN_ITEMS]: returnItems,
    [QuickActionType.CONTACT_A_BRAND]: contactABrand,
    [QuickActionType.TRACK_AN_ORDER]: trackAnOrder,
  };
};
